/* Collection interactions.

   Two things only: the mobile filter sheet, and auto-submitting the sort
   select. Filtering itself is plain links carrying query parameters, so the
   shelf works with JavaScript disabled — the design's rule that filter state
   lives in the URL is what makes that possible.
*/

(function () {
  'use strict';

  function setupSheet(root) {
    const sheet = root.querySelector('[data-dopa-sheet]');
    const opener = root.querySelector('[data-dopa-sheet-open]');
    if (!sheet || !opener) return;

    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      sheet.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = sheet.querySelector('a, button');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      sheet.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    opener.addEventListener('click', open);
    sheet.querySelectorAll('[data-dopa-sheet-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  function setupSort(root) {
    root.querySelectorAll('select[data-auto-submit]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  /* Empty-state suggestions carry the count each removal would produce.

     Shopify exposes no count for a hypothetical removal, so each suggestion
     fetches its own removal URL and reads the count the server rendered. The
     count is shown even when it is zero: a suggestion that leads to another
     empty grid is worse than no suggestion, so we say so rather than hide it.

     Without JavaScript the links still work; only the counts are missing. */
  function setupRemovalCounts(root) {
    const links = root.querySelectorAll("[data-dopa-count-url]");
    if (!links.length || typeof fetch !== "function") return;

    links.forEach(function (link) {
      const slot = link.querySelector("[data-dopa-count]");
      if (!slot) return;
      fetch(link.getAttribute("data-dopa-count-url"), { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, "text/html");
          const grid = doc.querySelectorAll(".dopa-grid__item");
          const stat = doc.querySelector(".dopa-collection__stats dd[data-tabular]");
          const n = grid.length || (stat ? parseInt(stat.textContent, 10) : 0);
          slot.textContent = String(isNaN(n) ? 0 : n);
        })
        .catch(function () { /* leave the count blank rather than guess */ });
    });
  }

  function init() {
    document.querySelectorAll('.dopa-collection').forEach(function (root) {
      setupSheet(root);
      setupSort(root);
      setupRemovalCounts(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
